const YTLoader = {
    init() {
        const script = document.createElement("script");
        script.src = "https://www.youtube.com/player_api";
        window.onYouTubePlayerAPIReady = () => {
            window.dispatchEvent(new CustomEvent("youtube-ready"));
        };
        document.body.appendChild(script);
    },
};
export default YTLoader;
